import { WorkflowStateStep } from 'hooks/useWorkflowStateMachine/types';
import { TranslationKey } from 'locales/fr';

export enum RoutesPath {
    Home = '',
    Login = 'login',
    ForgottenPassword = 'forgotten-password',
    ResetPassword = 'reset-password/:token/:customerId',
    Account = 'account',
    OrdersHistory = 'account/orders',
    OrderReceipt = 'account/orders/:orderId',
    OldRestaurants = 'restaurants',
    OldMenuHome = 'restaurants/:restaurantId',
    Restaurants = 'mode/:mode/restaurants',
    MenuHome = 'mode/:mode/restaurants/:restaurantId',
    Product = 'mode/:mode/restaurants/:restaurantId/products/:productId',
    ChoosePayment = 'payment/choose',
    CardPayment = 'payment/card',
    GooglePay = 'payment/google-pay',
    ApplePay = 'payment/apple-pay',
    Edenred = 'payment/edenred',
    Paygreen = 'payment/paygreen',
    LuncheonVoucherChoice = 'payment/voucher',
    PaymentLaterChoice = 'payment/later',
    NotFound = 'not-found',
    CrossSelling = 'cross-selling',
    Cart = 'cart',
    CartError = 'cart-error',
    AdditionalInformations = 'additional-informations',
    OrderConfirmation = 'order/:orderUuid',
    OrderFollowUp = 'order/:orderUuid/follow-up',
    OrderError = 'order-error',
    TimeError = 'time-error',
    NetworkError = 'network-error',
    TermsAndConditions = 'terms-and-conditions',
    MenuNotActivatedError = 'menu-not-activated-error',
}

export type RouteDeclaration = {
    name: TranslationKey;
    path: RoutesPath;
    element: React.ReactElement;
    layout: 'drawer' | 'mobile';
    state?: WorkflowStateStep;
    titleAccessor?: 'restaurantName';
};
